import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { Dayjs } from "dayjs";

class UpdateInboundSelectedChangeDateAction extends BaseAction<void, [Dayjs | null, Dayjs | null]> {

    override async run(): Promise<void> {
        updateRecoilState("inboundSelectedChangeDateAtom", this.params);
    }
}

export const updateInboundSelectedChangeDateAction = new UpdateInboundSelectedChangeDateAction()


